export const environment = {
  production: false,
  // tileswsUrl, railwsUrl, pcmwsUrl and singleSearchbaseUrl are also used by setting the SDK service Urls.
  tileswsUrl: 'https://tiles-qa.alk.com',
  railwsUrl: 'https://pcmrailqa.alk.com/REST/v23.1/Service.svc',
  pcmwsUrl: 'https://pcmiler-aws-qa.alk.com/APIs/REST/v1.0/service.svc',
  apiKey: '93C327D370843D46B031BFCE15AAFA0B',
  singleSearchbaseUrl: 'https://singlesearch-aws-qa.alk.com',
  singleSearchKey: 'A7FEE5D40BDF4A4A97D623094A657AFB',
  profileUrl: 'https://api-qa.trimblemaps.com/routing/v1/routingprofiles/',
  authwsUrl: 'https://authws-qa.alk.com/api/',
  ssoBaseUrl: 'https://authws-qa.alk.com/api/v2',
  daUrl: 'https://dataanywhere-qa.alk.com/api/',
  pcmilerAppUrl: 'https://qa.pcmilerweb.com/',
  braze: {
    baseUrl: 'https://rest.iad-01.braze.com',
    apiKey: '01e442af-cfcb-43ba-b63f-dbef1f587dac',
    // make this value smaller before demoing
    minimumIntervalBetweenTriggerActionsInSeconds: 30,
    enableLogging: true,
  },
  tokenExpiryTime: 1,
  chat: {
    enabled: true,
    regionWhitelist: ['NA'],
    wchatUrl: 'https://wchat.freshchat.com',
    // shared token for all environments
    fcToken: '797ed190-4ef3-4faa-81f8-367d7ba5e6dc',
  },
  applicationName: 'PCMilerWebsite',
  creditExpireWarningDays: 14,
  tidApplicationName: 'PC_Miler_Web--dev-qa',
  clientId: '4340ee42-2cd9-4fc6-9c3e-2721ae85e384',
  trimbleCloudUrl: 'https://stage.id.trimblecloud.com/oauth/',
  supportUrl: 'https://support.pcmilerweb.com/en/support/home',
  trialPeriod: '7 Days or 35 Routes',
  maxNoOfUser: 250,
  promo: {
    userId: 11553434,
    accountId: 127896,
    userName: 'rmehra+ian@alk.com',
    firstName: 'Rishi',
    lastName: 'Mehra',
    account: 'Trimble MAPS Marketing Offers',
  },
  daAccountsEnvBaseUrl: 'https://accounts-api-qa.trimblemaps.com/api/v1',
  daAuthwsEnvBaseUrl: 'https://authws-qa.alk.com/api',
  daFleetEnvBaseUrl: 'https://fleets-qa.trimblemaps.com/api/assets/v1',
  routingProfileUrl: 'https://api-qa.trimblemaps.com/routing/v1',
};
